<template>
  <ul class="social-links">
    <li>
      <a href="https://www.facebook.com/share/u9sqLHWa8JhkVU6G/?mibextid=WC7FNe" target="_blank">
        <i class="icon-facebook"></i>
      </a>
    </li>
    <li>
      <a href="https://www.instagram.com/nushenamel?igsh=MXViYjd4ZmRpZXF4Mw==" target="_blank">
        <i class="icon-insta"></i>
      </a>
    </li>
    <!--<li>-->
    <!--<a href="/">-->
    <!--<i class="icon-linkedin"></i>-->
    <!--</a>-->
    <!--</li>-->
    <!--<li>-->
    <!--<a href="/">-->
    <!--<i class="icon-pinterest"></i>-->
    <!--</a>-->
    <!--</li>-->
    <!--<li>-->
    <!--<a href="/">-->
    <!--<i class="icon-youtube"></i>-->
    <!--</a>-->
    <!--</li>-->
  </ul>
</template>

<script>
export default {
  name: 'social'
};
</script>

<style lang="scss">
.social-links {
  li {
    display: inline-block;
    margin-right: 20px;

    i {
      font-size: 24px;
    }
  }
}
</style>
